import { useId, type InputHTMLAttributes, type ReactNode } from "react";

/** Label above a 52px filled input; 16px text so iOS never zooms. */
export function TextField({
  label,
  hint,
  error,
  className,
  hideLabel = false,
  ...input
}: {
  label: ReactNode;
  hint?: ReactNode;
  error?: string;
  className?: string;
  hideLabel?: boolean;
} & InputHTMLAttributes<HTMLInputElement>) {
  const id = useId();
  const inputId = input.id ?? `field-${id}`;
  const described =
    [hint ? `${id}-hint` : "", error ? `${id}-error` : ""]
      .filter(Boolean)
      .join(" ") || undefined;
  return (
    <div className={`ui-field ui-text-field${className ? ` ${className}` : ""}`}>
      <label
        className={hideLabel ? "sr-only" : "ui-label"}
        htmlFor={inputId}
      >
        {label}
      </label>
      <input
        {...input}
        id={inputId}
        className="text-field"
        aria-invalid={error ? true : undefined}
        aria-describedby={described}
      />
      {hint ? (
        <span className="ui-hint" id={`${id}-hint`}>
          {hint}
        </span>
      ) : null}
      {error ? (
        <p className="ui-error" id={`${id}-error`} role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
